<template>
  <router-view />
</template>

<script>
export default {
  name: 'PublicLayout'
};
</script>
